import cn from 'classnames';
import useDate from 'hooks/useDate';
import { useUnit } from 'state/unit';
import useFormattable, { Formattable } from '../formattable';
import styles from './EpisodeDate.module.scss';

export interface EpisodeDateProps extends Formattable<string> {
  className?: string;
  format?: string;
}

const EpisodeDate: React.FC<EpisodeDateProps> = (props) => {
  const { className, format } = props;

  const unit = useUnit();
  const date = useDate({ format, timestamp: unit?.episode?.publishedAt });
  const formattedValue = useFormattable(date, props);

  return !date ? null : (
    <span className={cn(styles.root, className)}>{formattedValue}</span>
  );
};

export default EpisodeDate;
